function initReadingProgress() {
  const bar = document.querySelector('[data-reading-progress]');
  if (!bar || bar.dataset.progressInit) return;
  bar.dataset.progressInit = 'true';

  function update() {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const pct = docHeight > 0 ? Math.min(scrollTop / docHeight, 1) : 0;
    bar.style.transform = 'scaleX(' + pct + ')';
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
}

function initThoughtsFeatures() {
  initReadingProgress();
}

document.addEventListener('page:load', initThoughtsFeatures);
